// src/pages/RecipePage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { recipeData } from '../data/recipes';

function RecipePage() {
  // 1. Get the recipe ID from the URL
  const { id } = useParams(); // This gets the `id` from the URL (e.g., "1" from "/recipe/1")
  
  // 2. Find the recipe with the matching ID
  const recipe = recipeData.find(rec => rec.id === parseInt(id));

  // 3. If the recipe doesn't exist, show an error message
  if (!recipe) {
    return (
      <Container className="mt-4">
        <h2>Recipe Not Found</h2>
        <p>Sorry, we couldn't find the recipe you're looking for.</p>
      </Container>
    )
  }

  // 4. If the recipe exists, display it beautifully
  return (
    <Container className="mt-4">
      {/* Recipe Header Section */}
      <Row>
        <Col>
          <h1>{recipe.title}</h1>
          <p className="text-muted">Serves: {recipe.servings} | Prep: {recipe.prepTime} mins | Cook: {recipe.cookTime} mins</p>
        </Col>
      </Row>

      <hr />

      <Row>
        {/* Recipe Image */}
        <Col md={6}>
          <Card.Img 
            variant="top" 
            src={recipe.image} 
            alt={recipe.title}
            style={{ width: '100%', borderRadius: '8px' }}
          />
        </Col>

        {/* Ingredients List */}
        <Col md={6}>
          <Card>
            <Card.Header as="h3">Ingredients</Card.Header>
            <ListGroup variant="flush">
              {recipe.ingredients.map((ingredient, index) => (
                <ListGroup.Item key={index}>{ingredient}</ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        </Col>
      </Row>

      <hr />

      {/* Instructions */}
      <Row>
        <Col>
          <Card>
            <Card.Header as="h3">Instructions</Card.Header>
            <ListGroup variant="flush">
              {recipe.instructions.map((step, index) => (
                <ListGroup.Item key={index}>
                  <strong>Step {index + 1}:</strong> {step}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        </Col>
      </Row>

      {/* Description/Chef's Notes */}
      {recipe.description && (
        <>
          <hr />
          <Row>
            <Col>
              <Card>
                <Card.Header as="h3">Chef's Notes</Card.Header>
                <Card.Body>
                  <Card.Text>{recipe.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}

export default RecipePage;